import React from 'react';
import { observer, inject } from 'mobx-react';
import './style/input.less'

const YInput = inject('stepStore')(observer(({label, name, require, stepStore}: {
  label: string,
  name: string,
  require?: boolean,
  stepStore?: any
}) => {
  const change = (e: any, name: string) => {
    stepStore.updateForm(name, e.target.value);
  }

  return (
    <div
      className={`
      y-input 
      ${stepStore.valid[name] && !stepStore.valid[name].valid ? 'error' : ''}
      `}
    >
      <label htmlFor={name}>
        {label}
        {
          !!require && <span className="require">*</span>
        }
        {
          stepStore.valid[name] && !stepStore.valid[name].valid &&
          <span className='error'>{stepStore.valid[name].msg}</span>
        }
      </label>
      <input type='text' value={stepStore.form[name]} id={name} autoComplete='off' onChange={(e) => change(e, name)}/>
    </div>
  )
}))

export default YInput;
